// extracted by mini-css-extract-plugin
export default {"App_footer":"FooterComponent_App_footer__aTnzm","foot_bg":"FooterComponent_foot_bg__MoBrS","beian":"FooterComponent_beian__uwptD"};